import { createContext } from '@shared/utils/createContext';
import { CarouselContextProps } from './Carousel.types';

export const [CarouselProvider, useCarouselContext] = createContext<CarouselContextProps>({ name: 'CarouselProvider' });
